export default __webpack_public_path__ + "static/media/excavation3.7e81b81a.jpg";